export class UserRestrictions {  
    userId :String;
    entityId : String;
    entityType : String;
  id: any;
  view: any;
  edit: any;
  delete: any;
}